import { ParseAdapter } from "../abstract/ParseAdapter";
import { TchekImage } from "./image";
import { Tchekb } from "./tchekb.model";

export interface AttributeInterface {
    status: string,
    options: { name: string, values: string[] }[]
}

export class ImageClassification extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get tchekPtr(): Tchekb { return this.parseObject.get('tchekPtr') }
    set tchekPtr(value: Tchekb) { this.parseObject.set('tchekPtr', value); }

    get userPtr(): Parse.User { return this.parseObject.get('userPtr') }
    set userPtr(value: Parse.User) { this.parseObject.set('userPtr', value); }

    get forValidation(): boolean { return this.parseObject.get('forValidation') }
    set forValidation(value: boolean) { this.parseObject.set('forValidation', value); }

    get imagePtr(): TchekImage { return this.parseObject.get('imagePtr') }
    set imagePtr(value: TchekImage) { this.parseObject.set('imagePtr', value); }

    get attributes(): AttributeInterface { return this.parseObject.get('attributes') }
    set attributes(value: AttributeInterface) { this.parseObject.set('attributes', value); }
}




// WEBPACK FOOTER //
// ./src/app/model/imageClassification.model.ts